<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex sm6 xs12 md6 lg3>
        <material-stats-card color="orange" icon="mdi-store" title="订单量" :value="infoData.orderNum+''" small-value="单"
          sub-icon="mdi-viewList-outline" sub-text="商家总下单数量，包含未完成和退款订单" />
      </v-flex>
      <v-flex sm6 xs12 md6 lg3>
        <material-stats-card color="green" icon="mdi-cash" title="成交额" :value="'￥' + infoData.orderCom+''"
          sub-icon="mdi-calendar" sub-text="商家总成交额，仅包含已完成订单" />
      </v-flex>
      <v-flex sm6 xs12 md6 lg3>
        <material-stats-card color="info" icon="mdi-angular" title="下单金额" :value="'￥' + infoData.orderAll+''"
          sub-icon="mdi-calendar" sub-text="商家的总下单额，包含未完成和退款" />
      </v-flex>
      <v-flex sm6 xs12 md6 lg3>
        <material-stats-card color="red" icon="mdi-alert" title="退款金额" :value="'￥' + infoData.refundAll+''"
          sub-icon="mdi-calendar" sub-text="商家退款总额" />
      </v-flex>
      <v-flex md12 lg3>
        <material-card color="blue-grey" title="商家营业额排行">
          <v-data-table :headers="headers" :items="infoData.merchantList" hide-actions>
            <template slot="headerCell" slot-scope="{ header }">
              <span class="font-weight-light text-warning text--darken-3" v-text="header.text" />
            </template>
            <template slot="items" slot-scope="{ index, item }">
              <td>{{ index + 1 }}</td>
              <td>{{ item.merchantName }}</td>
              <td class="text-xs-right">￥ {{ (item.total).toFixed(2) }}</td>

            </template>
          </v-data-table>
        </material-card>
      </v-flex>
      <v-flex md12 lg3>
        <material-card color="green" title="商家订单量排行">
          <v-data-table :headers="headers2" :items="infoData.merchantNum" hide-actions>
            <template slot="headerCell" slot-scope="{ header }">
              <span class="font-weight-light text-success text--darken-3" v-text="header.text" />
            </template>
            <template slot="items" slot-scope="{ index, item }">
              <td>{{ index + 1 }}</td>
              <td>{{ item.merchantName }}</td>

              <td class="text-xs-right">{{ item.total }}</td>

            </template>
          </v-data-table>
        </material-card>
      </v-flex>

      <v-flex md12 lg3>
        <material-card color="red" title="商家退款额排行">
          <v-data-table :headers="headers" :items="infoData.merchantRefund" hide-actions>
            <template slot="headerCell" slot-scope="{ header }">
              <span class="font-weight-light text-success text--darken-3" v-text="header.text" />
            </template>
            <template slot="items" slot-scope="{ index, item }">
              <td>{{ index + 1 }}</td>
              <td>{{ item.merchantName }}</td>

              <td class="text-xs-right">￥ {{ (item.total).toFixed(2) }}</td>

            </template>
          </v-data-table>
        </material-card>
      </v-flex>
      <v-flex md12 lg3>
        <material-card color="orange" title="商家未结算订单排行">
          <v-data-table :headers="headers2" :items="infoData.merchantAwait" hide-actions>
            <template slot="headerCell" slot-scope="{ header }">
              <span class="font-weight-light text-success text--darken-3" v-text="header.text" />
            </template>
            <template slot="items" slot-scope="{ index, item }">
              <td>{{ index + 1 }}</td>
              <td>{{ item.merchantName }}</td>

              <td class="text-xs-right">共{{ item.total }}单 / ￥{{item.money}}元</td>

            </template>
          </v-data-table>
        </material-card>
      </v-flex>
       <v-flex sm12 xs12 md3 lg3>
          <v-select v-model="params.s_type" style="color: white;"
              :items="[ { label: '全部类别', value: '' }, { label: '大餐厅商户', value: 1 }, { label: '商业街商户', value: 2 }]"
              label="商户类别" item-text="label" item-value="value"  ></v-select>
       </v-flex>
       <v-flex sm12 xs12 md3 lg3>
            <v-select v-model="params.ru_id" :items="restaurantList" label="餐厅名称"  item-text="server_name"
             item-value="id"   ></v-select>
       </v-flex>

      <v-flex sm12 xs12 md6 lg6>
        <el-date-picker v-model="params.startDate" value="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
          placeholder="选择开始日期"></el-date-picker>-
        <el-date-picker v-model="params.endDate" value="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
          placeholder="选择结束日期"></el-date-picker>·
          <v-btn color="blue-grey" @click="getAnlysis()">查询</v-btn>
          <v-btn color="blue-grey" @click="exportexcel()">导出</v-btn>
      </v-flex>

        <!-- <v-btn v-if=' userRole == "admin"' color="blue" @click="forceGet()">同步用户数据</v-btn> -->
      <!-- </v-flex> -->

    </v-layout>
  </v-container>
</template>
  
<script>
import  * as XLSX from 'xlsx'
import fs from 'file-saver'
let _this;
export default {
  data() {
    return {
      userRole:sessionStorage.getItem('role'),
      infoData: {
        orderNum: 0,
        orderCom: 0,
        orderAll: 0,
        refundAll: 0
      },
      restaurantList:[],
      vipCount: 0,
      params: {
        s_type:'',
        startDate: '',
        endDate: '',
        ru_id:''
      },
      dailySalesChart: {
        data: {
          labels: ['12日', '13日', '14日', '15日', '16日', '17日', '19日'],
          series: [
            [0, 0, 0, 0, 0, 0, 0]
          ],
          turnoverGrowth: 0
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: 0,
          high: 100,
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      },
      dailySalesChart2: {
        data: {
          labels: ['12日', '13日', '14日', '15日', '16日', '17日', '19日'],
          series: [
            [0, 0, 0, 0, 0, 0, 0]
          ],
          turnoverGrowth: 0
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: 0,
          high: 100,
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      },
      dailySalesChart3: {
        data: {
          labels: ['12日', '13日', '14日', '15日', '16日', '17日', '19日'],
          series: [
            [0, 0, 0, 0, 0, 0, 0]
          ],
          turnoverGrowth: 0
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: 0,
          high: 100,
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      },
      headers: [
        {
          sortable: false,
          text: '#',
          value: 'id'
        },
        {
          sortable: false,
          text: '商户名称',
          value: 'merchantName'
        },

        {
          sortable: false,
          text: '订单金额',
          value: 'count',
          align: 'right'
        },
      ],
      items: [],
      headers2: [
        {
          sortable: false,
          text: '#',
          value: 'id'
        },
        {
          sortable: false,
          text: '商户名称',
          value: 'merchantName'
        },

        {
          sortable: false,
          text: '订单数量',
          value: 'total',
          align: 'right'
        },

      ],
      tabs: 0,
      list: {
        0: false,
        1: false,
        2: false
      },
      items2: [ ],
      dataMap: {
        orderNum: "订单数量",
        orderCom: "已完成订单数",
        orderAll: "订单总数",
        refundAll: "退款总数"
      },
      merchatlist: {
        merchantname: "订单数量",
        shanghu_id: "已完成订单数",
        totalall: "订单总数"
      },

    }
  },
  mounted() {
    _this = this;
    this.getToday()
    this.getAnlysis()
    this.getrestaurantList();
 },
  computed: {
    dateRangeText() {
      return this.dates.join(' ~ ')
    },
  },
  methods: {
    async forceGet(){
            this.$confirm(`此任务耗时较长，为避免影响线上业务，请避免在高峰期使用该功能，是否继续？`).then(async r => {
                 const res = await this.$post('admin/ForceGetMpUserList', {})
            })
        },
  formatTime(date){
     const time = date? new Date(date):new Date();
//   async formatTime(){
     //const time = new Date();
     const yyyy = time.getFullYear();
     const MM =String((time.getMonth()+1)).toString().padStart(2,'0');
     const dd=String(time.getDate().toString()).padStart(2,'0');
     const hh =String(time.getHours().toString()).padStart(2,'0');
     const mm =String(time.getMinutes().toString()).padStart(2,'0');
     const ss=String(time.getSeconds().toString()).padStart(2,'0');
     return `${yyyy}${MM}${dd}`;
},
    getTime(n) {
      const date = new Date()
      date.setTime(date.getTime() + n * 24 * 60 * 60 * 1000)
      const year = date.getFullYear()
      let month = `${date.getMonth() + 1}`
      let day = `${date.getDate()}`
      if (Number(month) < 10) month = `0${month}`
      if (Number(day) < 10) day = `0${day}`
      return `${year}-${month}-${day}`
    },
    getToday() {
      this.params.startDate = this.getTime(0)
      this.params.endDate = this.getTime(0)
    },
    //获取分析数据
    async getAnlysis() {
      const start = new Date(this.params.startDate + " 00:00:00").getTime()
      const end = new Date(this.params.endDate + " 23:59:59").getTime()
      if (start > end) {
        this.$message({
          message: '时间选择错误',
          type: 'error'
        })
        return
      }
      const res = await this.$post('admin/overview', { startTime: start, endTime: end,
         s_type:this.params.s_type,ru_id:this.params.ru_id })
      if (res.errno === 0) {
        this.infoData = res.data       
      }
    },
    async exportexcel(){
     try {
       const start = new Date(this.params.startDate + " 00:00:00").getTime()
       const end = new Date(this.params.endDate + " 23:59:59").getTime()
       if (start > end) {
         this.$message({
           message: '时间选择错误',
           type: 'error'
        })
        return
        }
       const res = await this.$post('alipay/exportexcel', { startTime: start, endTime: end,
       s_type:this.params.s_type,ru_id:this.params.ru_id })
       if (res.errno === 0) {
        //console.log(res.data)
       // 步骤1：将单对象转换为Excel可处理的数组结构
        const exportData = JSON.parse(JSON.stringify(res.data)); 
        if (exportData.length <= 1) { // 只有表头无数据
          alert('表格无有效数据，无需导出！');
          return;
        }

        const orderNum = Number(this.infoData.orderNum);
        const orderCom = Number(this.infoData.orderCom);
        const orderAll = Number(this.infoData.orderAll);
        const refund = Number(this.infoData.refundAll);
        const totalRow = {
          商家名称: '合计',       // 序号列显示“合计”
          下单金额:orderAll ,        // 商品名称列无数据，填“-”
          订单量: orderNum ,       // 单价列无数据，填“-”
          成交金额:orderCom ,    // 总数量
          退款金额: refund // 总金额
        }

         exportData.push(totalRow);
      // 创建工作簿
       const worksheet = XLSX.utils.json_to_sheet(exportData)   
       const workbook = XLSX.utils.book_new()
        // 将工作表添加到工作簿，命名为"用户数据"
        XLSX.utils.book_append_sheet(workbook, worksheet, '用户数据')

        // 3. 生成Excel文件并保存
        // 写入工作簿，生成二进制数据
        const excelBuffer = XLSX.write(workbook, { 
          bookType: 'xlsx', // 文件类型：xlsx
          type: 'array'     // 输出类型：数组
        })
        // 将二进制数据转换为Blob对象
        const blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        })
        // 保存文件（文件名可自定义）
       // fs.saveAs(blob, `用户数据_${new Date().getTime()}.xlsx`)  
        fs.saveAs(blob, `商户数据${this.formatTime(this.params.startDate)}-${this.formatTime(this.params.endDate)}.xlsx`)       
        this.$message.success('Excel导出成功！')
       } 
      } catch (error) {
        console.error('Excel导出失败：', error)
        this.$message.error('Excel导出失败，请重试！')
      }
    },
    async getrestaurantList() {
      const res = await this.$post('admin/getrestaurantList', {
        currentPage: 1,
        pageSize: 100,
      })
      res.data.data.unshift({ server_name: '全部餐厅', id: '' })
      this.restaurantList = res.data.data
    },    
    complete(index) {
      this.list[index] = !this.list[index]
    }
  }
}
</script>
  